import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

// Hide the public footer on every admin page + the auth flows. Using
// a startsWith('/manage') rule means new admin routes (e.g. today's
// /managereviews, earlier /managecourse) don't have to be remembered
// here — they're hidden automatically.
const ADMIN_FLAT_PATHS = ['/login', '/signup', '/forgot-password', '/contactinfo', '/settings'];

const FooterWithCondition = () => {
  const { pathname } = useLocation();
  const shouldHide =
    pathname.startsWith('/manage') || ADMIN_FLAT_PATHS.includes(pathname);
  if (shouldHide) return null;
  return <Footer />;
};

export default FooterWithCondition;
